var _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVerticalPerformance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 21.9785L17.5 21.9785L5.5 21.9785C5.2554 21.9656 4.96907 21.9751 4.66555 21.9852C4.32555 21.9965 3.96399 22.0085 3.61539 21.9905C2.64349 21.9405 1.77234 21.6579 1.75 20.4785L1.75 0.728516L3.25 0.728516L3.25 20.4785L4.75 20.4785L9.25 20.4785L10.75 20.4785L15.25 20.4785L16.75 20.4785L21.25 20.4785L23 20.4785L23 21.9785Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.61539 21.9905C2.64349 21.9405 1.77234 21.6579 1.75 20.4785L1.75 22L3.61539 21.9905Z",
    fill: "#222222"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 2,
    rx: 0.5,
    transform: "matrix(0 -1 -1 0 5 18)",
    fill: "#222222"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 2,
    rx: 0.5,
    transform: "matrix(0 -1 -1 0 5 14.5)",
    fill: "#222222"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 2,
    rx: 0.5,
    transform: "matrix(0 -1 -1 0 5 11)",
    fill: "#222222"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 2,
    rx: 0.5,
    transform: "matrix(0 -1 -1 0 5 7.5)",
    fill: "#222222"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 2,
    rx: 0.5,
    transform: "matrix(0 -1 -1 0 5 4)",
    fill: "#222222"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 4,
    rx: 0.5,
    transform: "matrix(0 -1 -1 0 23 19)",
    fill: "#222222"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 4,
    rx: 0.5,
    transform: "matrix(0 -1 -1 0 17 19)",
    fill: "#222222"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 4,
    rx: 0.5,
    transform: "matrix(0 -1 -1 0 11 19)",
    fill: "#222222"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalPerformance);
export default __webpack_public_path__ + "static/media/vertical_performance.006dfa3a.svg";
export { ForwardRef as ReactComponent };